import { render } from "./SpendingBreakdownChart.vue?vue&type=template&id=a3f2e616&ts=true"
import script from "./SpendingBreakdownChart.vue?vue&type=script&lang=ts"
export * from "./SpendingBreakdownChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__